/**
 * Où se rangent les bulles d'un fil (Kayla, 03-11-2026 : « l'affichage de base, c'est tout à gauche »).
 *
 *   · `a-gauche` (défaut) : tout le monde à gauche, l'avatar devant — le fil d'un outil de travail, où
 *     l'on lit qui parle par son nom et son avatar. Le sortant garde son voile plus clair.
 *   · `deux-cotes` : le fan à gauche, nous à droite — une messagerie de téléphone. Sur demande seulement.
 *
 * Le `Fil` la pose pour toutes ses bulles ; une `Bulle` hors d'un fil la prend en prop.
 */
import { createContext } from "react";

export type DispositionDuFil = "a-gauche" | "deux-cotes";

export const ContexteDisposition = createContext<DispositionDuFil>("a-gauche");
